export default __webpack_public_path__ + "static/media/benefit_1@3x.6d5697b1.png";